import { render, staticRenderFns } from "./text-string.vue?vue&type=template&id=4dcee026&scoped=true"
import script from "./text-string.vue?vue&type=script&lang=js"
export * from "./text-string.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcee026",
  null
  
)

export default component.exports